<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Vehicle Maintenance</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="noData" v-if="!vehicleDetailsList.length">
        <span>
          You have not added any Vehicle yet.
          <br />Click on Add Vehicle to add get started.
        </span>
        <form-add-button
          main_text="+ Add New"
          sub_text="vehicle"
          class="custom-add-button margin-t-l"
          @click="initCreateForm()"
        ></form-add-button>
      </div>
      <div v-if="vehicleDetailsList.length">
        <div class="row">
          <div class="col-6">
            <div class="d-heading">Vehicle details</div>
          </div>
          <div class="col-6">
            <div class="row-container justify-content-flex-end">
              <img src="@/assets/group-5.svg" class="Group-5" />
              <button class="text-green" @click="initCreateForm">Add New Vehicle</button>
            </div>
          </div>
        </div>
        <div class="margin-t-l">
          <data-table
            :columns="vehicleColumns"
            :tableData="vehicleDetailsList"
            :showinrow="true"
            :showhistory="false"
            :showedit="false"
            @delete="deleteItem($event)"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
                <p
                  v-if="slotprops.value.column.key != 'srNo'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              </div>
            </template>
          </data-table>
        </div>
        <tl-header type="h1" class="margin-t-l">
          <div class="d_heading">Vehicle Maintenance Details</div>
        </tl-header>
        <div class="row">
          <div class="col-3" v-if="vehicleDetailsList.length > 1">
            <tl-select
              label="Vehicle"
              labelText="vehicle_number"
              :options="vehicleDetailsList"
              v-model="model.vehicle"
              @change="(val) => model.vehicle=val"
            ></tl-select>
          </div>
          <div class="col-3">
            <txt label="Bill Number " name="bill_number" v-model="model.bill_number" />
          </div>
          <div class="col-3">
            <div class="label">
              <span class="input-label">Bill Date</span>
              <date-picker
                name="bill_date"
                :value="model.bill_date"
                @datevalue="(val)=> model.bill_date = val"
              />
            </div>
          </div>
          <div class="col-3">
            <txt label="Amount" type="number" name="amount" v-model="model.amount" />
          </div>
          <div class="col-12 margin-t-m">
            <div class="upload-heading">Upload bill</div>
            <upload @change="(val)=>docUrl=val.data.location" />
          </div>
          <div class="col-12 margin-t-m">
            <btn text="Add Bill" type="secondary" @click="addMaintenanceDetails()" />
          </div>
        </div>
        <div class="margin-t-l">
          <data-table
            :columns="tableColumns"
            :tableData="maintenanceDetailsList"
            :showinrow="true"
            :showhistory="false"
            :showedit="false"
            @delete="deleteItem($event)"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
                <p
                  v-if="slotprops.value.column.key != 'srNo'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <div class="row">
            <div class="col-8">
              <h3>Add Vehicle Details</h3>
            </div>
            <div class="col-4">
              <a href="javascript:void(0)" @click="okbtn" class="close-btn">close</a>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <txt
                label="Owner Name"
                name="owner_name"
                placeholder="owner name"
                v-model="vehicle.owner_name"
              />
            </div>
            <div class="col-6">
              <txt
                label="Vehicle Number"
                name="vehicle_number"
                placeholder="vehicle number"
                v-model="vehicle.vehicle_number"
              />
            </div>
            <div class="col-12 margin-t-m">
              <div class="upload-heading">Upload RC Book</div>
              <upload @change="(val)=>docUrl=val.data.location" />
            </div>
          </div>
          <div class="row margin-t-l">
            <div class="col-6 align-right">
              <btn text="Cancel" type="secondary" @click="okbtn"></btn>
            </div>
            <div class="col-6">
              <btn text="Save" type="primary" @click="addVehicleDetails()"></btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSuccessMsg: false,
      showModal: false,
      toast: false,
      errmsg: "",
      docUrl: "",
      model: {
        vehicle: "",
        bill_number: "",
        bill_date: "",
        amount: 0
      },
      vehicle: {
        owner_name: "",
        vehicle_number: "",
        rc_book_location: ""
      },
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      maintenanceDetailsList: [],
      vehicleColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Owner Name",
          key: "owner_name"
        },
        {
          label: "Vehicle Number",
          key: "vehicle_number"
        },
        {
          label: "RC Book",
          key: "document"
        }
      ],
      vehicleDetailsList: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      vmData: state => state.VM
    })
  },
  activated() {
    this.showSuccessMsg = false;
    this.setVMData();
  },
  methods: {
    ...mapActions({
      saveVMData: "dashboard/organisation/utilities/itdeclarations/saveVM"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        await this.saveVMData({
          id: this.$route.query.id,
          maintenanceDetailsList: this.maintenanceDetailsList,
          vehicleDetailsList: this.vehicleDetailsList,
          proofs: this.maintenanceDetailsList.map(item => {
            return item.proofs[0];
          })
        });
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setVMData() {
      try {
        if (this.vmData[this.$route.query.id]) {
          this.maintenanceDetailsList = this.vmData[
            this.$route.query.id
          ].maintenanceDetailsList;
          this.vehicleDetailsList = this.vmData[
            this.$route.query.id
          ].vehicleDetailsList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMaintenanceDetails() {
      try {
        this.maintenanceDetailsList.push({
          bill_number: this.model.bill_number,
          bill_date: this.model.bill_date,
          amount: this.model.amount,
          vehicle_number: this.model.vehicle.vehicle_number,
          proofs: [this.docUrl]
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addVehicleDetails() {
      try {
        this.vehicleDetailsList.push({
          owner_name: this.vehicle.owner_name,
          vehicle_number: this.vehicle.vehicle_number,
          rc_book_location: [this.docUrl]
        });
        this.showModal = false;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    initCreateForm() {
      this.showModal = true;
    },
    okbtn() {
      this.showModal = false;
    },
    resetForm() {
      try {
        this.model = {
          vehicle_number: "",
          bill_number: "",
          bill_date: "",
          amount: 0
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteItem(record) {
      try {
        let index = this.vehicleDetailsList.findIndex(
          item => item.name == record.name
        );
        this.vehicleDetailsList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.custom-add-button {
  text-align: center;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
.close-btn {
  float: right;
  margin-top: 15px;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.upload-heading {
  font-size: 13px;
  opacity: 0.78;
  font-weight: 500;
}
.justify-content-flex-end {
  justify-content: flex-end;
}
</style>
